var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { IntlProvider } from 'react-intl';
import React from 'react';
export function getFirstSupportedLocale(messages, defaultLocale, allowShort) {
    if (allowShort === void 0) { allowShort = false; }
    if (window.Liferay && window.Liferay.ThemeDisplay && window.Liferay.ThemeDisplay.getLanguageId) {
        var locale = window.Liferay.ThemeDisplay.getLanguageId();
        if (messages[locale.substring(0, 2)]) {
            return locale.replace('_', '-');
        }
    }
    var browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
    if (Array.isArray(window.navigator.languages)) {
        for (var i = 0; i < window.navigator.languages.length; i++) {
            if ((allowShort || window.navigator.languages[i].length > 2) &&
                messages[window.navigator.languages[i].substring(0, 2)]) {
                return window.navigator.languages[i];
            }
        }
    }
    for (var i = 0; i < browserLanguagePropertyKeys.length; i++) {
        var language = window.navigator[browserLanguagePropertyKeys[i]];
        if (language && (allowShort || language.length > 2) && messages[language.substring(0, 2)]) {
            return language;
        }
    }
    return defaultLocale;
}
export function withIntl(_a) {
    var messages = _a.messages;
    var locale = getFirstSupportedLocale(messages, 'de-CH', true);
    var msgs = messages[locale.substring(0, 2)];
    return function withIntlHoc(Component) {
        function Wrapper(props) {
            return (React.createElement(IntlProvider, { locale: locale, messages: msgs, defaultLocale: "de-CH" },
                React.createElement(Component, __assign({}, props))));
        }
        Wrapper.displayName = (Component.displayName || Component.name || 'Widget') + "WithToasts";
        return Wrapper;
    };
}
//# sourceMappingURL=intl.js.map